import React, { useState, useEffect } from 'react';
import api from '../../../config/axios';
import Swal from 'sweetalert2';
import { FaTimes, FaRegSave } from 'react-icons/fa';

const UnidadeModal = ({ isOpen, onClose, onUnidadeSelecionada, unidadeSelecionada, gestoraId, usuario }) => {
  const [unidades, setUnidades] = useState([]);
  const [unidadeId, setUnidadeId] = useState('');

  const fetchUnidades = async () => {
    if (!gestoraId) return;
    try {
      Swal.fire({
        title: 'Carregando...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });

      let lista = [];
      
      if (usuario && usuario.dadosColaborador && usuario.dadosColaborador.unidade_designacao_id) {
        if (usuario.dadosColaborador.unidadesVinculadas && usuario.dadosColaborador.unidadesVinculadas.length > 0) {
          lista = usuario.dadosColaborador.unidadesVinculadas.map(vinculo => ({
            value: vinculo.unidade.id,
            label: vinculo.unidade.nome
          }));
        } else {
          lista = [{
            value: usuario.dadosColaborador.unidade.id,
            label: usuario.dadosColaborador.unidade.nome
          }];
        }
      } else {
        const response = await api.get(`/gestoras/${gestoraId}/unidades`, { params: { page: 1, limit: 100 } });
        lista = (response.data?.unidades || []).map(u => ({ value: u.id, label: u.nome }));
      }
      
      setUnidades(lista);
      Swal.close();
    } catch (err) {
      Swal.close();
      Swal.fire('Erro', 'Não foi possível carregar unidades.', 'error');
    }
  };

  useEffect(() => {
    if (isOpen) {
      if (unidadeSelecionada) setUnidadeId(unidadeSelecionada.id);
      fetchUnidades();
    }
  }, [isOpen, gestoraId, usuario]);

  const handleSubmit = async () => {
    try {
      Swal.fire({
        title: 'Carregando...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });

      if (!unidadeId) setUnidadeId(null);
      const response = await api.post('/set-unidade', { unidade_id: unidadeId });
      localStorage.setItem('token', response.data.token);
      
      if (unidadeId) {
        const unidade = unidades.find(u => u.value === parseInt(unidadeId));
        onUnidadeSelecionada(unidade);
      }
      else onUnidadeSelecionada(null);
      Swal.close();
      Swal.fire('Sucesso', 'Unidade definida com sucesso!', 'success');      
      onClose();
    } catch (err) {
      Swal.close();
      Swal.fire('Erro', 'Não foi possível definir a unidade.', 'error');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-md modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="fw-bold mt-2">Unidade</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-12">
                <label className="form-label fw-bold">Unidade</label>
                <select
                  className="form-select"
                  value={unidadeId}
                  onChange={(e) => setUnidadeId(e.target.value)}
                >
                  {!usuario?.dadosColaborador?.unidade_designacao_id && (
                    <option value="">Nenhuma</option>
                  )}
                  {unidades.map(u => (
                    <option key={u.value} value={u.value}>{u.label}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-outline-danger" type="button" onClick={onClose}>
              <FaTimes /> Fechar
            </button>
            <button className="btn btn-custom-primary" type="button" onClick={handleSubmit}>
              <FaRegSave /> Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnidadeModal;
